import { merchantCompanyState } from './merchantCompany.state';
import { merchantCompanyActions } from './merchantCompany.actions';
import { merchantCompanyGetters } from './merchantCompany.getters';
import { merchantCompanyMutations } from './merchantCompany.mutations';

export default {
  state: merchantCompanyState,
  actions: merchantCompanyActions,
  getters: merchantCompanyGetters,
  mutations: merchantCompanyMutations,
};
